// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__BN9N5","amount":"Amount_amount__3xQS5","tip":"Amount_tip__2xpGv","tipHeader":"Amount_tipHeader__9hbga","tipsWrap":"Amount_tipsWrap__7SCAk"};